import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Tailwind-aware className combiner.
 *
 * The design system defines custom `fontSize` tokens (`text-display-xl`,
 * `text-headline`, `text-body`, `text-label`, …). Stock `tailwind-merge`
 * doesn't know these, so it lumps them into the same conflict group as
 * `text-white` / `text-ink` (colour) and silently drops the colour class.
 * We register the custom sizes here so size and colour never collide.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'display-2xl',
            'display-xl',
            'display-lg',
            'headline',
            'body-lg',
            'body',
            'body-sm',
            'label',
            'caption',
            'mono-sm',
          ],
        },
      ],
    },
  },
});

/** Tailwind-aware className combiner. Used by every shadcn/Radix primitive. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
